<span (click)="openModal()">
  <ng-container *ngTemplateOutlet="template"></ng-container>
</span>
